import gql from 'graphql-tag'

/**
 * Query
 */
const GET_WITH_PAGINATION = gql`
query discountControlWithPagination($page: Int, $perPage: Int, $filters: FiltersDiscountControl) {
  discountControlWithPagination(page: $page, first: $perPage, filters: $filters){
    paginatorInfo {
      currentPage
      count
      hasMorePages
      perPage
      total
    }
    data {
      id
      employee_id
      employee {
        id
        name
        last_name
        document_type
        document_number
        mothers_last_name
        fullName
        email
      }
      discount_type_id
      discountType {
        id
        name
      }
      date
      amount
      amount_text
      type
      observations
      frequency
      frequency_text
    }
  }
}
`

const GET_ALL = gql`
  query discountControls ($filters: FiltersDiscountControl) {
    discountControls (filters: $filters) {
      id
      employee_id
      employee {
        id
        name
        last_name
        document_type
        document_number
        mothers_last_name
        fullName
        email
      }
      discount_type_id
      discountType {
        id
        name
      }
      date
      amount
      amount_text
      type
      observations
      frequency
      frequency_text
    }
  }
`

/**
 * Mutations
 */
const CREATE = gql`
  mutation createDiscountControl ($input: DiscountControlForm!) {
    createDiscountControl (input: $input) {
      id
      employee_id
    }
  }
`

const UPDATE = gql`
  mutation updateDiscountControl ($id: ID!, $input: DiscountControlForm!) {
    updateDiscountControl (id: $id, input: $input) {
      id
      employee_id
    }
  }
`

const DELETE = gql`
  mutation deleteDiscountControl ($id: ID!) {
    deleteDiscountControl(id: $id) { 
      id
    }
  }
`

export {
  GET_WITH_PAGINATION,
  CREATE,
  UPDATE,
  DELETE,
  GET_ALL
}
